import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_payments_tabs = _resolveComponent("backer-center-payments-tabs")
  const _component_backer_center_payments_skeleton = _resolveComponent("backer-center-payments-skeleton")
  const _component_backer_center_payments_card = _resolveComponent("backer-center-payments-card")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_filter_view = _resolveComponent("filter-view")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    size: "narrow",
    title: _ctx.Resources.BackerCenter.SectionPaymentsHeader,
    "current-view": "payments"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_filter_view, {
        filters: $setup.paymentsFilters,
        "hidden-filter-keys": ['searchType'],
        "hidden-selected-keys": ['searchType'],
        "filter-list-title": _ctx.Resources.Search.SearchFiltersHeader,
        "sort-list-title": _ctx.Resources.Search.SearchProjectSortTitle
      }, {
        header: _withCtx(({ filters, onFilterChange }) => [
          _createVNode(_component_backer_center_payments_tabs, {
            class: "_mb-4",
            "current-search-type": filters.searchParams.value.searchType,
            onTabSelected: (type) => onFilterChange('searchType', type)
          }, null, 8 /* PROPS */, ["current-search-type", "onTabSelected"])
        ]),
        default: _withCtx(({ items, isProcessing, canLoadMore, loadMore, isLoadingMore }) => [
          _createVNode(_component_box, {
            class: "_flexcol _separated--x _separated--light",
            content: ""
          }, {
            default: _withCtx(() => [
              isProcessing
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                    return _createVNode(_component_backer_center_payments_skeleton, {
                      key: `skeleton:${n}`
                    })
                  }), 64 /* STABLE_FRAGMENT */))
                : ($options.hasPayments)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (payment) => {
                        return (_openBlock(), _createBlock(_component_backer_center_payments_card, _mergeProps({
                          key: payment.paymentID
                        }, { ref_for: true }, payment, {
                          "search-type": $setup.paymentsFilters.searchParams.value.searchType
                        }), null, 16 /* FULL_PROPS */, ["search-type"]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      isLoadingMore
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                            return _createVNode(_component_backer_center_payments_skeleton, {
                              key: `skeleton:${n}`
                            })
                          }), 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      canLoadMore
                        ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                            key: 1,
                            onLoadMore: loadMore
                          }, null, 8 /* PROPS */, ["onLoadMore"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createBlock(_component_empty_state, {
                      key: 2,
                      title: _ctx.Resources.BackerCenter.PaymentsEmptyStateHeader,
                      description: _ctx.Resources.BackerCenter.PaymentsEmptyStateParagraph,
                      "data-qa": "backer-center-view-payments:EmptyState"
                    }, null, 8 /* PROPS */, ["title", "description"]))
            ]),
            _: 2 /* DYNAMIC */
          }, 1024 /* DYNAMIC_SLOTS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["filters", "filter-list-title", "sort-list-title"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}